import PropTypes from 'prop-types';
import React, { useState } from 'react';

import TabWrapper, {
  TabMenu,
  MenuItem,
  TabContent,
  TabPanel,
} from './tabs.style';
import { Icon } from 'react-icons-kit';

const Tab = ({ active, className, children, callback }) => {
  const [state, setState] = useState({
    active: active || 0,
  });

  const handleChange = (index, callback) => {
    if (callback && typeof callback === 'function') callback(index);
    setState({ active: index });
  };

  const addAllClasses = ['rq_tab'];
  if (className) {
    addAllClasses.push(className);
  }

  return (
    <TabWrapper className={addAllClasses.join(' ')}>
      <TabMenu className="tab_menu">
        {children.map((element, index) => {
          const { icon, title } = element.props;
          let activeClass = index === state.active ? 'active' : '';
          return (
            <MenuItem
              key={index}
              className={activeClass}
              onClick={() => handleChange(index, callback)}
            >
              {icon && <Icon icon={icon} id={icon.id} />}
              {title}
            </MenuItem>
          );
        })}
      </TabMenu>
      <TabContent className="tab_content">{children[state.active]}</TabContent>
    </TabWrapper>
  );
};

export const Panel = ({ children, callback }) => (
  <TabPanel className="tab_panel">{children}</TabPanel>
);

Tab.propTypes = {
  children: PropTypes.array,
  active: PropTypes.number.isRequired,
  callback: PropTypes.func
};

Panel.propTypes = {
  children: PropTypes.element,
  callback: PropTypes.func,
  title: PropTypes.string.isRequired,
};

export default Tab;
